<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    color: {
      type: String,
      default: 'success'
    },
    icon: {
      type: String,
      default: ''
    },
    noButton: {
      type: Boolean
    },
    noIcon: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'locale'])
  },
  methods: {
    relocate() {
      this.$router.push({
        name: this.isAuthenticated ? 'dashboard' : 'login',
        params: { locale: this.locale }
      })
    }
  }
}
</script>
<template>
  <v-card width="500">
    <DialogBaseText>
      <v-row v-if="!noIcon" class="justify-center text-center">
        <v-col>
          <v-icon :color="color" size="74" class="icon_border_round">{{
              icon
            }}</v-icon>
        </v-col>
      </v-row>
      <slot></slot>
    </DialogBaseText>
    <v-divider></v-divider>
    <DialogBaseActions v-if="!noButton">
      <v-btn color="primary" class="white--text px-8 py-2" @click="relocate"
      ><span>Ok</span></v-btn
      >
    </DialogBaseActions>
  </v-card>
</template>
